var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "275.000000pt",
    height: "275.000000pt",
    viewBox: "0 0 275.000000 275.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,275.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490 2050 l0 -180 175 0 175 0 0 180 0 180 -175 0 -175 0 0 -180z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207 2224 c-4 -4 -7 -85 -7 -181 l0 -173 180 0 180 0 -2 178 -3 177 -171 3 c-93 1 -173 -1 -177 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 2050 l0 -180 175 0 175 0 0 180 0 180 -175 0 -175 0 0 -180z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 1535 l0 -75 890 0 890 0 0 75 0 75 -890 0 -890 0 0 -75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 1235 l0 -75 890 0 890 0 0 75 0 75 -890 0 -890 0 0 -75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.71ced9865e0b18bdd1b8f6eaddbbeba8.svg";
export { ForwardRef as ReactComponent };